import React from 'react'
import GridList from '@material-ui/core/GridList'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import Button from '@material-ui/core/Button'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../containers/dockPadStyle'
import classNames from 'classnames'
import { compose } from 'redux'
import { connect } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FileCopyIcon from '@material-ui/icons/FileCopy'
import ButtonBase from '@material-ui/core/ButtonBase'
import {
  withFirebase,
  firebaseConnect,
  isLoaded,
  isEmpty,
  populate
} from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates'
import CircularProgress from '@material-ui/core/CircularProgress'
import { filesActions } from '../actions/files.actions';
import { filesConstants } from '../constants/files.constants.js'



class FileList extends React.Component {
  constructor(props) {
    super(props)
    let processedFile = {};
     if (!!this.props.value) {
        processedFile = {...props.value }
      }

    this.state = {
      processedFile: processedFile
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      processedFile: nextProps.value
    })
  }

  _renderIcon(item) {
    const { classes } = this.props;

    if (item.status === filesConstants.DOWNLOADED) {
      return (
        <div className={classes.FileItemGridContainer}>
          <FileCopyIcon className={classes.FileItemCopyIcon} />
          <Typography className={classes.FileItemFileName}>{item.fileName}</Typography>
        </div>
      )
    } else if (item.status == 'error') {
      return <p>Error</p>
    } else if (item.status === filesConstants.UPLOADING) {
      return (
        <div className={classes.FileItemGridContainerCircularProgress}>
          <CircularProgress />
        </div>
      )
    }
  }

  _renderIconNewFile(item) {
    const { classes } = this.props;
      return (
        <div className={classes.FileItemGridContainer}>
          <FileCopyIcon className={classes.FileItemCopyIcon} />
          <Typography className={classes.FileItemFileName}>{item.name}</Typography>
        </div>
      )
  }

  fileSelectedHandler = (event) => {
    const { selectedProject, taskId, dispatch } = this.props;

    let file = event.target.files[0];

    if (!!this.props.entity) {
      dispatch(filesActions.uploadFile(selectedProject.uid, taskId, file))
    } else {
      this.props.getFilesFromUpload(file)
    }
  }

  renderNewGridList() {
    const newFiles = this.props.filesNewTask

    const { classes } = this.props

    if(newFiles.length <= 0) return 

    return (
      <GridList className={classes.gridList} cols={2.5}>
        {newFiles.map(file => {
          return (
            <GridListTile className={classes.FileListGridTile}>
              {this._renderIconNewFile.call(this, file)}
            </GridListTile>
          )
        })}
      </GridList>
    )
  }

  renderOldGridList() {
    const value = dockPadEntityMapToList(this.state.processedFile)
    const { classes } = this.props

    if(value.length <= 0) return

    return (

      <GridList className={classes.gridList} cols={2.5}>
        {value.map(file => {
          return (
            <GridListTile className={classes.FileListGridTile} key={file.uid}>
              <a target="_blank" href={file.fileDownloadURL} download={file.fileName}>
                {this._renderIcon.call(this, file)}
              </a>
            </GridListTile>
          )
        })}
      </GridList>
    )
  }

  render() {
    const { classes } = this.props

    if (!this.props.entity) {
      return (
        <div className={classNames(classes.standardMarginBottom, classes.standardSeperated)}>
          <Typography variant="body1" className={classes.FilesTypography}>Files</Typography>

          <Button  component="label"  >
            <AddCircleIcon
              className={classNames(classes.standardRightMargin)}
            />
              <input
                type="file"
                style={{ display: "none" }}
                onChange={this.fileSelectedHandler}
              />
          </Button>
          {this.renderNewGridList()}
        </div>
      )
    } else {
      return (
          <div className={classNames(classes.standardMarginBottom)}>
            <Typography variant="body1" className={classes.FilesTypography}>Files</Typography>

            <Button  component="label" >
              <AddCircleIcon
                className={classNames(classes.standardRightMargin)}
              />
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={this.fileSelectedHandler}
                />
            </Button>
            {this.renderOldGridList()}
          </div>
      )
    }

  }
}

FileList.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired
}

FileList.defaultProps = {
  onChange: () => {},
  value: {}
}
export default compose(
  withFirebase,
  connect((state, props) => {
    const currentUserId = state.firebase.auth.uid;
    return {
        currentUserId
    }
  }),
  withStyles(styles, { withTheme: true })
)(FileList)



// WEBPACK FOOTER //
// ./src/components/FileList.tsx